(function () {
    'use strict';
    angular.module('finansApp.employeeListController', []).controller('employeeListController', employeeListController);
    
    employeeListController.$inject = ['employeeService'];


    function employeeListController(employeeService) {
        var vm = this;
        vm.state = employeeService.state;

        function init() {

            // Once we have the data, init the images with responsive
            setTimeout(function() {
                novicell.responsiveImages.init();
            }, 500);
        }

        vm.isAssociate = function(item) {

            if(vm.state.associates.splitList)
            {
                if(!item.IsAssociate) {
                    return true;
                } else {
                    return false;
                }
            }

            return true; // otherwise it won't be within the results

        }
        
        employeeService.getEmployees().then(init, init);


    }

})();